/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Export_Video_AriaInputs */

const en_file_export_video_aria = /** @type {(inputs: File_Export_Video_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export video file with burnt-in captions`)
};

const fr_file_export_video_aria = /** @type {(inputs: File_Export_Video_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exporter un fichier video avec sous-titres incrustes`)
};

const de_file_export_video_aria = /** @type {(inputs: File_Export_Video_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videodatei mit eingebetteten Untertiteln exportieren`)
};

const it_file_export_video_aria = /** @type {(inputs: File_Export_Video_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esporta file video con sottotitoli incorporati`)
};

const ru_file_export_video_aria = /** @type {(inputs: File_Export_Video_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Экспорт видеофайла со встроенными субтитрами.`)
};

const es_file_export_video_aria = /** @type {(inputs: File_Export_Video_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar archivo de vídeo con subtítulos incorporados`)
};

const zh_cn2_file_export_video_aria = /** @type {(inputs: File_Export_Video_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导出带有内嵌字幕的视频文件`)
};

const ja_file_export_video_aria = /** @type {(inputs: File_Export_Video_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`焼き付けキャプション付きのビデオファイルをエクスポートする`)
};

const hi_file_export_video_aria = /** @type {(inputs: File_Export_Video_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो फ़ाइल को कैप्शन सहित निर्यात करें`)
};

const pt_pt2_file_export_video_aria = /** @type {(inputs: File_Export_Video_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exportar arquivo de vídeo com legendas incorporadas`)
};

/**
* | output |
* | --- |
* | "Export video file with burnt-in captions" |
*
* @param {File_Export_Video_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_export_video_aria = /** @type {((inputs?: File_Export_Video_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Export_Video_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_export_video_aria(inputs)
	if (locale === "de") return de_file_export_video_aria(inputs)
	if (locale === "it") return it_file_export_video_aria(inputs)
	if (locale === "ru") return ru_file_export_video_aria(inputs)
	if (locale === "es") return es_file_export_video_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_file_export_video_aria(inputs)
	if (locale === "ja") return ja_file_export_video_aria(inputs)
	if (locale === "hi") return hi_file_export_video_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_file_export_video_aria(inputs)
	return en_file_export_video_aria(inputs)
});